/**
 * 模块: 统计卡片组件
 * 职责: 显示数据统计信息
 * 限制: 文件<280行, 函数<30行
 */

import React from 'react';
import { Card, Statistic, Row, Col } from 'antd';
import { BarChartOutlined, LineChartOutlined } from '@ant-design/icons';
import { Stats } from './types';

interface StatsCardProps {
  stats: Stats;
}

const StatsCard: React.FC<StatsCardProps> = ({ stats }) => {
  return (
    <Card className="stats-card" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={6}>
          <Statistic
            title="总记录数"
            value={stats.totalRecords}
            prefix={<BarChartOutlined />}
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="周期数"
            value={stats.periodCount}
            prefix={<LineChartOutlined />}
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="唯一搜索词数"
            value={stats.uniqueKeywords}
            precision={0}
          />
        </Col>
        <Col span={6}>
          <Statistic
            title="唯一ASIN数"
            value={stats.uniqueASINs}
            precision={0}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default StatsCard;

